"use client";
import { usePathname } from "next/navigation";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/app/components/shadcn/breadcrumb";
import { useAppDispatch } from "@/app/lib/features/redux/redux.hook";
import { closeStory } from "@/app/lib/features/story/story.slice";

const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || "https://www.tozlu.com";

interface DynamicBreadcrumbProps {
  title: string | null;
  /**
   * BreadcrumbList JSON-LD'sini de bas. Varsayılan true.
   *
   * Sayfa zaten sunucu tarafında kendi BreadcrumbList'ini basıyorsa false
   * geçilmeli — aynı sayfada iki BreadcrumbList olursa Google hangisini
   * kullanacağını kendisi seçiyor ve çelişkili veri uyarısı üretebiliyor.
   * Şu an tek örneği [slug] sayfası (bkz. app/(pages)/[slug]/page.tsx).
   */
  withJsonLd?: boolean;
}

const DynamicBreadcrumb = ({
  title,
  withJsonLd = true,
}: DynamicBreadcrumbProps) => {
  const pathname = usePathname();
  const dispatch = useAppDispatch();
  const label = title || "Ürünler";

  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Anasayfa",
        item: SITE_URL,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: label,
        item: `${SITE_URL}${pathname}`,
      },
    ],
  };

  return (
    <>
      {withJsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
        />
      )}
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink href="/" onClick={() => dispatch(closeStory())}>
              Anasayfa
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink href="#" className="font-medium text-black">
              {label}
            </BreadcrumbLink>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </>
  );
};

export default DynamicBreadcrumb;